import { Controller } from "@hotwired/stimulus"
import { toggleReply, cancelReply, submitComment, submitReplyComment } from "../shared/comment_replies"

export default class extends Controller {
  static targets = ["count", "list", "form", "textarea", "replyForm", "commentSection", "spoilerOverlay", "spoilerBody", "spinner", "commentsSentinel"]
  static values = { url: String }

  connect() {
    this.currentReplyForm = null
    this.spoilerModal = null
    this.commentsLoaded = false
    this.loadingComments = false
    this.nextCommentsPage = null
    this.commentsObserver = null

    this.pendingCommentId = null
    const match = window.location.hash.match(/^#comment-(\d+)$/)
    if (match) this.pendingCommentId = parseInt(match[1])

    this.commentSectionTarget.classList.remove("d-none")
    this.loadComments(1)
  }

  disconnect() {
    if (this.commentsObserver) {
      this.commentsObserver.disconnect()
    }
  }

  loadComments(page) {
    this.loadingComments = true
    this.spinnerTarget.classList.remove("d-none")

    fetch(`${this.urlValue}?page=${page}`)
      .then(response => response.json())
      .then(data => {
        this.spinnerTarget.classList.add("d-none")
        this.listTarget.insertAdjacentHTML("beforeend", data.html)
        this.countTarget.textContent = `(${data.total_count})`
        this.nextCommentsPage = data.next_page
        this.loadingComments = false

        if (this.pendingCommentId) {
          const el = this.element.querySelector(`[data-comment-id="${this.pendingCommentId}"]`)
          if (el) el.scrollIntoView({ behavior: 'smooth' })
          this.pendingCommentId = null
        }

        if (!this.commentsLoaded) {
          this.commentsLoaded = true
          this.observeCommentsSentinel()
        }
      })
      .catch(() => {
        this.spinnerTarget.classList.add("d-none")
        this.loadingComments = false
      })
  }

  observeCommentsSentinel() {
    if (!this.hasCommentsSentinelTarget) return

    this.commentsObserver = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (entry.isIntersecting && this.nextCommentsPage && !this.loadingComments) {
          this.loadComments(this.nextCommentsPage)
        }
      }),
      { rootMargin: "200px" }
    )

    this.commentsObserver.observe(this.commentsSentinelTarget)
  }

  toggleComments() {
    this.commentSectionTarget.classList.toggle("d-none")
    if (!this.commentsLoaded && !this.commentSectionTarget.classList.contains("d-none")) {
      this.loadComments(1)
    }
  }

  showSpoilerModal() {
    this.spoilerModal = new bootstrap.Modal(document.getElementById("spoilerModal"))
    document.getElementById("spoilerConfirmBtn").onclick = () => this.revealBody()
    this.spoilerModal.show()
  }

  revealBody() {
    this.spoilerOverlayTarget.classList.add("d-none")
    this.spoilerBodyTarget.classList.remove("d-none")
    if (this.spoilerModal) {
      this.spoilerModal.hide()
      this.spoilerModal = null
    }
  }

  toggleReply(event) {
    toggleReply(this, event, "fandom-comments")
  }

  cancelReply(event) {
    cancelReply(this, event)
  }

  submit(event) {
    event.preventDefault()

    const content = this.textareaTarget.value.trim()
    if (!content) return

    submitComment(this.urlValue, "content", content)
      .then(data => {
        if (data.success) {
          this.textareaTarget.value = ""
          this.countTarget.textContent = `(${data.comments_count})`
          this.listTarget.insertAdjacentHTML('beforeend', data.html)
        }
      })
  }

  submitReply(event) {
    event.preventDefault()

    const form = event.currentTarget
    const textarea = form.querySelector('textarea')
    const content = textarea.value.trim()
    if (!content) return

    const parentId = form.dataset.parentId

    submitReplyComment(this.urlValue, "content", content, parentId)
      .then(data => {
        if (data.success) {
          const commentItem = this.element.querySelector(`[data-comment-id="${parentId}"]`)
          const repliesContainer = commentItem.querySelector('.replies-container')
          repliesContainer.insertAdjacentHTML('beforeend', data.html)

          if (this.currentReplyForm) {
            this.currentReplyForm.classList.add('d-none')
            this.currentReplyForm.innerHTML = ''
            this.currentReplyForm = null
          }
        }
      })
  }
}
